const app_name = import.meta.env.APP_NAME || 'PASSIE protocol';
const app_id = app_name.replace(/\s+/g, '').toLowerCase();
const app_domain = import.meta.env.APP_DOMAIN || 'https://passieprotocol.nl';
const app_author = import.meta.env.APP_AUTHOR || 'AppComm';
const app_author_url = import.meta.env.APP_AUTHOR_URL || 'https://appcomm.nl';
const app_root_api = import.meta.env.APP_ROOT_API || `${app_domain}/api`;
const app_with_credentials = import.meta.env.APP_WITH_CREDENTIALS === 'true';

export const environment = {
  production: import.meta.env.NODE_ENV === 'production',
  APP_NAME: `${app_name}`,
  APP_DESCRIPTION: `${app_name} made by ${app_author}`,
  APP_ID: `nl.appcomm.${app_id}`,
  APP_DOMAIN: `${app_domain}`,
  APP_IMAGE_URL: `${app_domain}`,
  APP_NO_IMAGE_URL: `model_images/no-image.png`,
  APP_ROOT_API: `${app_root_api}`,
  APP_WITH_CREDENTIALS: app_with_credentials,

  APP_TOOLBAR_APP_NAME: false,
  APP_ONBOARDING: true,
  APP_AUTH_OVERVIEW: false,

  APP_AUTHOR: `${app_author}`,
  APP_AUTHOR_URL: `${app_author_url}`,

  PUSHER: import.meta.env.PUSHER_ENABLED === 'true',
  PUSHER_APP_ID: `${import.meta.env.PUSHER_APP_ID || ''}`,
  PUSHER_KEY: `${import.meta.env.PUSHER_KEY || ''}`,
  PUSHER_SECRET: `${import.meta.env.PUSHER_SECRET || ''}`,
  PUSHER_CLUSTER: `${import.meta.env.PUSHER_CLUSTER || ''}`,
};
